import DynamicFieldsAPI from './dynamic-fields-api';

export default DynamicFieldsAPI;
